import { siteConfig } from '../data/siteConfig';
import type { FeatureKey, NavItem } from '../types/content';

export function isFeatureEnabled(feature: FeatureKey): boolean {
  return Boolean(siteConfig.features[feature]);
}

export function visibleNavItems(items: NavItem[]): NavItem[] {
  return items.filter((item) => !item.feature || isFeatureEnabled(item.feature));
}
